<template>
    <v-container>
        <h3 class="mb-5">ดาวน์โหลดผลการประเมินหัวหน้าส่วนงาน</h3>

        <v-card elevation="2" :loading="loading" :disabled="loading">
            <v-card-title>เงื่อนไขการดาวน์โหลด</v-card-title>
            <v-card-text>
                <v-form v-model="valid">
                    <v-row>
                        <v-col cols="12">
                            <v-select label="เลือกแบบประเมิน" :items="assessments" item-text="title"
                                item-value="assessmentId" dense outlined v-model="assessmentId" :return-object="false"
                                :rules="requiredRule"></v-select>
                        </v-col>
                        <v-col cols="12">
                            <v-select label="เลือกผู้รับการประเมิน" :items="assessees" item-text="name"
                                item-value="assesseeId" dense outlined v-model="assesseeId" :loading="assesseeLoading"
                                :return-object="false" :rules="requiredRule"></v-select>
                        </v-col>
                        <v-col cols="12">
                            <h4>เลือกข้อมูลที่ต้องการดาวน์โหลด <v-btn color="primary" text
                                    @click="selectAllData">เลือกทั้งหมด</v-btn></h4>
                            <div v-for="(item, index) in questions" :key="index" class="d-flex flex-row mt-2">
                                <v-checkbox v-model="dataNames" :value="item.dataName"></v-checkbox>
                                <div v-html="item.name" class="ml-2"></div>
                            </div>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" :disabled="!valid" @click="download">Download</v-btn>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
import server from '../../../../services/server';
import ui from '../../../../services/ui';

export default {
    name: "AssessmentReportExport",

    data() {
        return {
            assessments: [],
            loading: false,
            assesseeLoading: false,
            assessmentId: 0,
            assesseeId: 0,
            assessees: [],
            valid: false,
            requiredRule: [ui.requiredRule],
            questions: [],
            dataNames: []
        }
    },

    watch: {
        assessmentId(v) {
            if (v) this.loadAssessees()
        }
    },

    async mounted() {
        this.loading = true
        this.assessments = await server.get('report/assessment_items/' + this.$route.params.id)
        this.loading = false
    },

    methods: {
        async loadAssessees() {
            this.assesseeLoading = true
            this.assessees = await server.get('report/assessment_assessee_items/' + this.assessmentId)
            this.questions = await server.get('report/assessment_question_items/' + this.assessmentId)
            this.dataNames = []
            this.assesseeLoading = false
        },
        async download() {
            const data = this.dataNames.join(',')
            const url = process.env.VUE_APP_SERVER + 'api/report/assessment_data_download/' + this.assesseeId + '?data=' + data
            window.open(url)
        },
        selectAllData() {
            this.dataNames = []

            for (let i = 0; i < this.questions.length; i++) {
                this.dataNames.push(this.questions[i].dataName)
            }
        }
    }
}
</script>